import {useEffect, useState} from 'react'
import _ from 'lodash'
import {Button, Popup} from 'semantic-ui-react'
import WindowedSelect from 'react-windowed-select'
import './style.css'

export interface IAddWordsProps {
  currentValue: string[]
  options: string[]
  disabled?: boolean
  onAdd: (val: string[]) => void
}

interface DDOption {
  label: string
  value: string
}

export function AddWords(props: IAddWordsProps) {
  const {
    // currentValue,
    options,
    disabled,
    onAdd,
  } = props

  const [isOpen, setIsOpen] = useState(false)
  const [currentValueOptions, _setCurrentValueOptions] = useState<DDOption[]>([])
  const [dropdownOptions, setDropdownOptions] = useState<DDOption[]>([])

  // useEffect(() => {
  //     setCurrentValueOptions(
  //         _.chain(dropdownOptions)
  //         .filter(v => _.includes(currentValue, v.value))
  //         .value()
  //     );
  // }, [currentValue]);

  useEffect(() => {
    if (isOpen && options.length === 0) setIsOpen(false)
    setDropdownOptions(
      _.chain(options)
        .sort()
        .map((o) => ({
          label: o,
          value: o,
        }))
        .value()
    )
  }, [options])

  return (
    <Popup
      open={isOpen}
      disabled={disabled}
      position='left center'
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
      className='label-popup'
      openOnTriggerMouseEnter={false}
      closeOnTriggerMouseLeave={false}
      trigger={
        <Button
          compact
          size='tiny'
          icon='add'
          color='blue'
          disabled={disabled || options?.length === 0}
        />
      }
      style={{
        zIndex: 9999999,
      }}
    >
      <WindowedSelect
        isMulti
        isSearchable
        autoFocus
        defaultMenuIsOpen
        className='word-dropdown'
        placeholder='add word(s)...'
        menuPlacement='bottom'
        maxMenuHeight={200}
        windowThreshold={50}
        menuIsOpen={true}
        value={currentValueOptions}
        menuShouldScrollIntoView={false}
        options={dropdownOptions}
        styles={{
          option: (provided, state) => ({
            ...provided,
            borderBottom: '1px dotted pink',
            color: state.isFocused ? 'white' : 'black',
            background: state.isFocused ? '#ff099a' : 'transparent',
          }),
        }}
        onChange={(data: any) => {
          onAdd(_.map(data, 'value'))
        }}
      />
    </Popup>
  )
}
